import { PackageProduct } from "../model";
import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";
import { mapPackageProduct } from "./mappers/mapPackageProduct";

export async function getPackageProducts(divisionId?: number): Promise<PackageProduct[]> {
    const localApi = await getLocalApi();
    const query = typeof divisionId === 'number' ? `?divisionId=${divisionId}` : '';

    return await localApi.fetchList(
        `${apiConfig.packages_get_all}${query}`,
        mapPackageProduct,
        "Failed to fetch package products"
    );
}